export function initBurger() {
  const burgerButtonEl = document.getElementById("burgerButton");
  if (burgerButtonEl) {
    burgerButtonEl.addEventListener("change", (e) => {
      burgerMenu(e.target.parentElement);
    });
  }
}

function burgerMenu(burger) {
  if (burger) {
    burger.classList.toggle("burger__button--open");
  }
  const navbarMenu = document.querySelector(".navbar-menu");
  if (!navbarMenu) return;

  navbarMenu.classList.toggle("navbar-menu--show");

  const overlayHeaderEl = document.querySelector(".overlay");
  if (!overlayHeaderEl) return;

  overlayHeaderEl.classList.toggle("overlay--show");

  const headerLogoEl = document.querySelector('.header__left');
  if (headerLogoEl) {
    headerLogoEl.classList.toggle('header__logo--hide');
  }

  const headerWrapperEl = document.querySelector('.header__wrapper');
  if (headerWrapperEl) {
    headerWrapperEl.classList.toggle('header__wrapper--hide');
  }
}
